/* istanbul ignore file */
import { loadScript } from '@web/common/Utils'
import { IS_WEB } from '@web/common/config'
import snakeCase from 'lodash.snakecase'
import { Router } from 'vue-router'
import sentry from '@web/common/sentry'
import getBaseUrl from '@web/common/getBaseUrl'
import urlParse from 'url-parse'
import Logger from '@web/common/Logger'

export default class GoogleTagManager {
  static id: string
  static config: Record<string, unknown>
  static typelk?: AnalyticsTypeLk

  static setConfig (config: Record<string, unknown>) {
    GoogleTagManager.config = {
      ...GoogleTagManager.config,
      ...config
    }
    if (window.gtag) {
      // Используем gtag('set', ...) вместо повторного gtag('config', id, ...),
      // т.к. повторный config-вызов триггерит автоматический page_view в GA4
      // (даже при send_page_view: false в merged-конфиге). MOB-164.
      window.gtag('set', config)
    }
  }

  static logException () {
    if (!window.gtag) {
      if (process.env.NODE_ENV === 'production') {
        sentry.captureMessage('GTag not init')
      }
      // Logger.info('GTag not init')
    }
  }

  static init ({ id, userId, typelk }: { id: string, userId?: string | null, typelk?: AnalyticsTypeLk | null }): void {
    loadScript(`https://www.googletagmanager.com/gtag/js?id=${id}`)
    window.dataLayer = window.dataLayer || []
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function gtag (...args) {
      window.dataLayer = window.dataLayer || []
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments)
    }
    gtag('js', new Date())
    GoogleTagManager.id = id
    window.gtag = gtag
    let transportUrlInstance = ''
    try {
      const urlInstance = urlParse(getBaseUrl(''), true)
      const host = urlInstance.host.replace('dev.', '')
      transportUrlInstance = urlParse(`${urlInstance.protocol}//sst.${host}`, true).toString()
    } catch (error) {
      Logger.error('Error parsing transport URL', error)
    }
    const config = {
      send_page_view: true,
      transport_url: transportUrlInstance.toString(),
      ga4_id: id,
      ...(userId ? { user_id: userId } : {}),
      ...(typelk ? { type_lk: typelk } : {})
    }
    GoogleTagManager.config = config
    gtag('config', id, config)
  }

  static send ({ action, ...options }: EventBase): void {
    if (!window.gtag) {
      GoogleTagManager.logException()
      window.dataLayer?.push({
        event: action,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ...(options as any)
      })
      return
    }
    window.gtag('event', action, options)
  }

  static setUserId (id: string | null): void {
    if (!window.gtag) {
      GoogleTagManager.logException()
      return
    }
    GoogleTagManager.setConfig({
      user_id: id
    })
  }

  static setTypeLk (typelk?: AnalyticsTypeLk): void {
    if (!window.gtag) {
      GoogleTagManager.logException()
      return
    }
    GoogleTagManager.typelk = typelk
    GoogleTagManager.setConfig({ type_lk: GoogleTagManager.typelk })
  }

  static pageView (router: Router): void {
    // if (!window.gtag) {
    //   GoogleTagManager.logException()
    //   return
    // }
    // const params = {}
    // for (const name in router.currentRoute.value.params) {
    //   params[snakeCase(name)] = String(router.currentRoute.value.params[name])
    // }
    // SEE: https://developers.google.com/analytics/devguides/collection/ga4/page-view
    // window.gtag('event', 'page_view', {
    //   ...params,
    //   page_title: router.currentRoute.value.meta?.title || '',
    //   page_location: window.location.href,
    //   page_path: IS_WEB ? window.location.pathname : router,
    //   send_to: GoogleTagManager.id,
    //   ...(GoogleTagManager.typelk ? { type_lk: GoogleTagManager.typelk } : {})
    // })
  }
}
